import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { QRCodeSVG } from 'qrcode.react';
import Button from '../common/Button';
import { FaCopy, FaCheckCircle } from 'react-icons/fa';

const Wrapper = styled.div`
    margin-top: 20px;
    text-align: center;
`;

const Instructions = styled.p`
    margin-bottom: 10px;
`;

const Amount = styled.p`
    font-size: 18px;
    margin-bottom: 10px;
    strong {
        color: ${({ theme }) => theme.colors.primaryDark};
    }
`;

const Expiry = styled.p`
    font-size: 14px;
    color: ${({ theme }) => theme.colors.gray};
    margin-bottom: 20px;
    strong {
        font-weight: 700;
        color: ${({ theme }) => theme.colors.danger};
    }
`;

const QRCodeContainer = styled.div`
    padding: 10px;
    background: white;
    border-radius: ${({ theme }) => theme.radii.md};
    display: inline-block;
    border: 1px solid ${({ theme }) => theme.colors.lightGray};
`;

const CopyButton = styled(Button)`
  width: 100%;
  margin-top: 20px;
  font-size: 16px;
`;

const VerificationStatus = styled.p`
    margin-top: 20px;
    font-size: 14px;
    color: ${({ theme }) => theme.colors.gray};
`;

const QRCodeDisplay = ({ paymentData }) => {
                console.log(paymentData);

    const [copySuccess, setCopySuccess] = useState('');
    const [timeLeft, setTimeLeft] = useState(paymentData?.expires_in || 1800);
    useEffect(() => {
        if (timeLeft <= 0) return;
        const timer = setTimeout(() => setTimeLeft(prev => prev - 1), 1000);
        return () => clearTimeout(timer);
    }, [timeLeft]);

    const handleCopy = () => {
        if (!paymentData?.qr_code) return;
        navigator.clipboard.writeText(paymentData.qr_code).then(() => {
            setCopySuccess('Copiado!');
            setTimeout(() => setCopySuccess(''), 2000);
        }, (err) => {
            console.error('Falha ao copiar:', err);
            setCopySuccess('Falha ao copiar');
        });
    };

    const formatTime = (seconds) => {
        const mins = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
    };

    const formatValue = (value) => {
        return ((Number(value) || 0) / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    };

    return (
        <Wrapper>
            <Instructions>Para continuar, pague com Pix escaneando o código abaixo.</Instructions>
            <Amount>Valor: <strong>{formatValue(paymentData.valor)}</strong></Amount>
            <Expiry>Expira em: <strong>{formatTime(timeLeft)}</strong></Expiry>
            
            <QRCodeContainer>
                <QRCodeSVG value={paymentData.qr_code || ''} size={220} includeMargin={true} />
            </QRCodeContainer>

            <CopyButton onClick={handleCopy}>
                {copySuccess ? <><FaCheckCircle /> {copySuccess}</> : <><FaCopy /> Copiar Código Pix</>}
            </CopyButton>
            
            <VerificationStatus>Aguardando confirmação do pagamento...</VerificationStatus>
        </Wrapper>
    );
};

export default QRCodeDisplay;